<div class="create-user-container">
  <!-- PIQET Logo Section -->
  <div class="logo">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="logo-main">
            <div class="ourlogo">
              <img src="/assets/images/Piqet_NewLogo.png" alt="Logo" />
            </div>
            <div class="rightside-text">
              <div class="logo1">
                Powering your <br />
                sustainability journey
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-container">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

  <!-- Registration Form -->
  <div *ngIf="!isLoading && !hasError && newUserData" class="registration-form-container">
    <div class="registration-header">
      <h2>Create your account</h2>
      <p class="text-muted">Please fill in the information below to create your account</p>
    </div>

    <!-- Embed the manage user component -->
    <piqet-angular-new-my-organization-manage-user
      [customData]="newUserData"
      [modalLabel]="'Create Account'"
      [organizationId]="organizationId"
      [isStandaloneMode]="true"
      [hideOrganizationField]="true"
      [hideRoleField]="true"
      [hideTriggerAutomation]="true"
      (saveManageUserEvent)="onSaveUser($event)"
      (cancelEvent)="onCancel()"
    >
    </piqet-angular-new-my-organization-manage-user>
  </div>

  <!-- Copyright Footer -->
  <div class="copyright">
    <a href="https://www.lifecycles.com.au/" target="_blank" class="linkText"
      >© Life Cycle Strategies Pty Ltd</a
    >
  </div>
</div>
